import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {DIAGRAM_VERSION_STATES_ENUM} from '../models/diagram-version.constant';
import {get} from 'lodash';

@Pipe({
  name: 'getDiagramStateLabel',
  standalone: true
})
export class GetDiagramStateLabelPipe implements PipeTransform {
  private notReadyLabel: string = this.translateSvc.instant(
    'VERSIONING.NOT_READY_FOR_AUTHORISATION_LABEL'
  );
  private readyForAuthorisationLabel: string = this.translateSvc.instant(
    'VERSIONING.READY_FOR_AUTHORISATION_LABEL'
  );
  private beingAuthorisedLabel: string = this.translateSvc.instant(
    'VERSIONING.BEING_AUTHORISED_DIAGRAM_LABEL'
  );
  private noAuthorisersLabel: string = this.translateSvc.instant('VERSIONING.NO_AUTHORISERS_LABEL');
  private ableToOverrideLabel: string = this.translateSvc.instant('VERSIONING.ABLE_TO_OVERRIDE');
  constructor(private translateSvc: TranslateService) {}
  transform(diagram, isOverride: boolean): string {
    const hasAuthorisers = get(diagram, 'hasAuthorisers', false);

    switch (true) {
      case diagram.state === DIAGRAM_VERSION_STATES_ENUM.BEING_AUTHORISED:
        return this.beingAuthorisedLabel;

      case diagram.state === DIAGRAM_VERSION_STATES_ENUM.DRAFT && isOverride:
        return this.ableToOverrideLabel;

      case !hasAuthorisers:
        return this.noAuthorisersLabel;

      case diagram.state === DIAGRAM_VERSION_STATES_ENUM.DRAFT && diagram.readyToAuthorise:
        return this.readyForAuthorisationLabel;

      case diagram.state === DIAGRAM_VERSION_STATES_ENUM.DRAFT && !diagram.readyToAuthorise:

      default:
        return this.notReadyLabel;
    }
  }
}
